module.exports = __webpack_public_path__ + "img/guarapuava.42f1012f.png";